<div style="margin: 10px;">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
            <span  [ngClass]="menu_now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <div style="padding:30px;margin-left:10px ;" *ngIf="menu_now=='2'">
        <!-- --primary -->
        <button class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-xl" (click)="defaultdata();now='3';sub_now='2'"  style="margin-bottom: 0.5%;">新增排程推播設定</button>
        <select class="form-control" style="width: 160px;margin-left: 3%;display: inline-block;" [(ngModel)]="search_gender" (change)="init_list()">
            <option *ngFor="let item of gender_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <select class="form-control" style="width: 160px;margin-left: 3%;display: inline-block;" [(ngModel)]="search_time" (change)="init_list()">
            <option value="-1">推播時間不限</option>
            <option *ngFor="let item of time_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <!-- <select name="selectedQuantity"  class="form-control" (change)="init_list()" [(ngModel)]="search_type_id" style="margin-bottom: 1%;">
            <option *ngFor="let option of type_list" [value]="option.id" >{{option.name}}</option>
        </select> -->
        <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent" [data]="data">
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'view'">
                    <div style="display: flex;">
                        <div style="margin-right: 5%;">
                            <img loading="lazy" *ngIf="post.val.gender == 1 && post.val.info.has_pic == 1  && post.val.info.is_fuzzy == 0 " style="width: 50px" src="{{guser}}" alt="圖片不見囉">
                            <img loading="lazy" *ngIf="post.val.gender == 2 && post.val.info.has_pic == 1  && post.val.info.is_fuzzy == 0 " style="width: 50px" src="{{buser}}" alt="圖片不見囉">
                            <img loading="lazy" *ngIf="post.val.gender == 1 && post.val.info.has_pic == 2  && post.val.info.is_fuzzy == 0 " style="width: 50px" src="{{ganimate}}" alt="圖片不見囉">
                            <img loading="lazy" *ngIf="post.val.gender == 2 && post.val.info.has_pic == 2  && post.val.info.is_fuzzy == 0 " style="width: 50px" src="{{banimate}}" alt="圖片不見囉">
                            <img loading="lazy" *ngIf="post.val.gender == 1 && post.val.info.has_pic == 1  && post.val.info.is_fuzzy == 1 " style="width: 50px" src="{{guserfleeze}}" alt="圖片不見囉">
                            <img loading="lazy" *ngIf="post.val.gender == 2 && post.val.info.has_pic == 1  && post.val.info.is_fuzzy == 1 " style="width: 50px" src="{{buserfleeze}}" alt="圖片不見囉">
                            <img loading="lazy" *ngIf="post.val.gender == 1 && post.val.info.has_pic == 2  && post.val.info.is_fuzzy == 1 " style="width: 50px" src="{{ganimatefleeze}}" alt="圖片不見囉">
                            <img loading="lazy" *ngIf="post.val.gender == 2 && post.val.info.has_pic == 2  && post.val.info.is_fuzzy == 1 " style="width: 50px" src="{{banimatefleeze}}" alt="圖片不見囉">
                            <img loading="lazy" *ngIf="post.val.info.has_pic == 0" style="width: 50px">

                        </div>
                        <div>
                            <!-- <p style="font-weight: bold;text-align: left;margin-bottom: 0px;font-size: 17px;">{{post.val.title_tpl}}</p> -->
                            <p style="font-weight: bold;text-align: left;margin-bottom: 0px;font-size: 17px;" class="wrapped-text">
                                <ng-container *ngIf="post.val.title_tpl?.length > 13; else noWrapTexttitle">
                                  {{post.val.title_tpl | slice:0:13}}<br>{{post.val.title_tpl | slice:13}}
                                </ng-container>
                                <ng-template #noWrapTexttitle>
                                  {{post.val.title_tpl}}
                                </ng-template>
                            </p>
                            <!-- <p style="margin-bottom: 0px;">{{post.val.content_tpl | slice:0:17}}<span *ngIf="post.val.content_tpl.length > 17">...</span></p> -->
                            <p style="margin-bottom: 0px; text-align: left;" class="wrapped-text">
                                <ng-container *ngIf="post.val.content_tpl?.length >999; else noWrapText">
                                  {{post.val.content_tpl | slice:0:17}}<br>{{post.val.content_tpl | slice:17}}
                                </ng-container>
                                <ng-template #noWrapText>
                                  {{post.val.content_tpl}}
                                </ng-template>
                            </p>
                        </div>
                    </div>
                </div>
                <div *ngIf="post.key == 'gender'">
                    {{genderarr[post.val.gender]}}
                </div>
                <div *ngIf="post.key == 'ps_id'">
                    {{time_list[(post.val.ps_id-1)]?.name}}
                </div>
                <div *ngIf="post.key == 'is_enable'">
                    <app-checkswitch [item]="post.val" [enabletype]="1" [type]='2' (statusChange)="handleStatusChange($event)"></app-checkswitch>
                    <!-- <button class="btn" (click)="post.val.is_enable=1;save(post.val,-1)" [class]="post.val.is_enable==1?'btn-success':'btn-secondary'">上架</button>
                    <button class="btn" (click)="post.val.is_enable=0;save(post.val,-1)" [class]="post.val.is_enable==1?'btn-secondary':'btn-danger'" style='margin-left: 10px;'>下架</button> -->
                </div>
                <div *ngIf="post.key == 'gg'">
                    <button class="btn btn-info" (click)="edit_data=post.val;now='1'"  data-toggle="modal" data-target=".bd-example-modal-xl">編輯多標題</button>
                    <button class="btn btn-warning" (click)="edit_data=post.val;checktag();now='2';sub_now='2'"  data-toggle="modal" data-target=".bd-example-modal-xl" style='margin-left: 10px;'>編輯設定檔</button>
                </div>
            </ng-template>
        </app-table-v2>
    </div>
    <div *ngIf="menu_now=='1'">
        <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent_active" [data]="data">
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'gg'">
                    <button class="btn btn-success" (click)="edit_data=post.val;now='2'"  data-toggle="modal" data-target=".bd-example-modal-xl" style='margin-left: 10px;'>編輯設定檔</button>
                </div>
            </ng-template>
        </app-table-v2>
    </div>
    <div *ngIf="menu_now=='4'" style="padding: 30px;margin-left: 10px;">

        <app-date [time]="time"  [timeset]="timeset" (rangeSelected)="handleRangeSelected($event)"></app-date>


        <select class="form-control" style="width: 160px;margin-left: 3%;margin-bottom: 1%;display: inline-block;" [(ngModel)]="search_gender" (change)="default_page();">
            <option *ngFor="let item of gender_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <select class="form-control" style="width: 160px;margin-left: 3%;margin-bottom: 1%;display: inline-block;" [(ngModel)]="search_time" (change)="default_page();">
            <option value="-1">推播時間不限</option>
            <option *ngFor="let item of time_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <div class="wait3-note">
            資料將於滿三日後納入統計
        </div >

        <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent_push" [data]="data" (sortdata)="handlesortdata($event)">
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'view'">
                    <div style="display: flex;">
                        <div style="margin-right: 5%;">
                            <img loading="lazy"  *ngIf="post.val.img_1 != ''" style="width: 50px" src="{{post.val.img_1}}" alt="圖片不見囉">
                            <img loading="lazy" *ngIf="post.val.img_1 == ''" style="width: 50px">

                        </div>
                        <div>
                            <!-- <p style="font-weight: bold;text-align: left;margin-bottom: 0px;font-size: 17px;">{{post.val.title_tpl}}</p> -->
                            <p style="font-weight: bold;text-align: left;margin-bottom: 0px;font-size: 17px;" class="wrapped-text">
                                <ng-container *ngIf="post.val.title?.length > 13; else noWrapTexttitle">
                                  {{post.val.title | slice:0:13}}<br>{{post.val.title | slice:13}}
                                </ng-container>
                                <ng-template #noWrapTexttitle>
                                  {{post.val.title}}
                                </ng-template>
                            </p>
                            <!-- <p style="margin-bottom: 0px;">{{post.val.content_tpl | slice:0:17}}<span *ngIf="post.val.content_tpl.length > 17">...</span></p> -->
                            <p style="margin-bottom: 0px; text-align: left;" class="wrapped-text">
                                <ng-container *ngIf="post.val.content?.length >999; else noWrapText">
                                  {{post.val.content | slice:0:17}}<br>{{post.val.content | slice:17}}
                                </ng-container>
                                <ng-template #noWrapText>
                                  {{post.val.content}}
                                </ng-template>
                            </p>
                        </div>
                    </div>
                </div>
            </ng-template>
        </app-table-v2>
    </div>
    <div  style="padding:30px;margin-left:10px ;" *ngIf="menu_now=='3'">

        <select class="form-control" style="width: 160px;margin-bottom:1%;display: inline-block;" [(ngModel)]="search_gender" (change)="init_push_type_tpl_list()">
            <option *ngFor="let item of gender_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <select class="form-control" style="width: 160px;margin-left: 3%;margin-bottom:1%;display: inline-block;" [(ngModel)]="search_is_enable" (change)="init_push_type_tpl_list()">
            <option value="-1">狀態不限</option>
            <option *ngFor="let item of is_enable_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent_push_type_tpl_active" [data]="data">
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'gender'">
                    <div *ngIf="post.val.gender == 1">男</div>
                    <div *ngIf="post.val.gender == 2">女</div>
                    <div *ngIf="post.val.gender == 3">不限(官方帳號)</div>
                </div>
                <div *ngIf="post.key == 'is_enable'">
                    <div *ngIf="post.val.is_enable == 0">停用</div>
                    <div *ngIf="post.val.is_enable == 1">啟用</div>
                </div>
                <div *ngIf="post.key == 'gg'">
                    <button class="btn btn-success" (click)="edit_data=post.val;now='2'"  data-toggle="modal" data-target=".bd-example-modal-xl" style='margin-left: 10px;'>編輯設定檔</button>
                </div>
            </ng-template>
        </app-table-v2>
    </div>
    <div  style="padding:30px;margin-left:10px ;" *ngIf="menu_now=='5'">
        <div style="display: flex;">
            <app-date [time]="time"  [timeset]="timeset" (rangeSelected)="handleRangeSelected($event)"></app-date>

            <select class="form-control" style="width: 160px;margin-bottom: 2%;margin-right: 0.5%;display: inline-block;" [(ngModel)]="search_notification" (change)="init_list()">
                <option *ngFor="let item of Notification_method_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <h6 style="margin-right: 3%;margin-top: 0.3%;">
                總儲值次數：{{recharge_num}}
            </h6>

            <h6 style="margin-right: 3%;margin-top: 0.3%;">
                總儲值金額：{{recharge}}
            </h6>

            <h6 style="margin-right: 3%;margin-top: 0.3%;">
                總推播數：{{push_num}}
            </h6>

            <h6 style="margin-right: 3%;margin-top: 0.3%;">
                總推播點擊率：{{click_num_rate}}
            </h6>

            <h6 style="margin-right: 3%;margin-top: 0.3%;">
                總簡訊數：{{sms_push_num}}
            </h6>

            <h6 style="margin-right: 3%;margin-top: 0.3%;">
                總簡訊點擊率：{{sms_click_num_rate}}
            </h6>
        </div>
        <div class="wait3-note">
            資料將於滿三日後納入統計
        </div >
        <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent_once_push" [data]="data" (sortdata)="handlesortdata($event)">
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'view'">
                    <div style="display: flex;">
                        <div style="margin-right: 5%;">
                            <img loading="lazy"  *ngIf="post.val.img_1 != ''" style="width: 50px" src="{{post.val.img_1}}" alt="圖片不見囉">
                            <img loading="lazy" *ngIf="post.val.img_1 == ''" style="width: 50px">
                        </div>
                        <div>
                            <!-- <p style="font-weight: bold;text-align: left;margin-bottom: 0px;font-size: 17px;">{{post.val.title_tpl}}</p> -->
                            <p style="font-weight: bold;text-align: left;margin-bottom: 0px;font-size: 17px;" class="wrapped-text">
                                <ng-container *ngIf="post.val.title?.length > 13; else noWrapTexttitle">
                                  {{post.val.title | slice:0:13}}<br>{{post.val.title | slice:13}}
                                </ng-container>
                                <ng-template #noWrapTexttitle>
                                  {{post.val.title}}
                                </ng-template>
                            </p>
                            <!-- <p style="margin-bottom: 0px;">{{post.val.content_tpl | slice:0:17}}<span *ngIf="post.val.content_tpl.length > 17">...</span></p> -->
                            <p style="margin-bottom: 0px; text-align: left;" class="wrapped-text">
                                <ng-container *ngIf="post.val.content?.length >999; else noWrapText">
                                  {{post.val.content | slice:0:17}}<br>{{post.val.content | slice:17}}
                                </ng-container>
                                <ng-template #noWrapText>
                                  {{post.val.content}}
                                </ng-template>
                            </p>
                        </div>
                    </div>
                </div>
                <div *ngIf="post.key == 'inform_method'">
                    <div *ngIf="post.val.inform_method == 1">推播</div>
                    <div *ngIf="post.val.inform_method == 2">簡訊</div>
                    <div *ngIf="post.val.inform_method == 3">推播+簡訊</div>
                </div>

                <div *ngIf="post.key == 'sms_status'">
                    <div *ngIf="post.val.sms_status == 0">未通知</div>
                    <div *ngIf="post.val.sms_status == 1">已通知</div>
                </div>


                <div *ngIf="post.key == 'is_enable'">
                    <div *ngIf="post.val.is_enable == -2">取消</div>
                    <div *ngIf="post.val.is_enable == -1  && post.val.inform_method == 2">不發(沒有配對到)</div>
                    <div *ngIf="post.val.is_enable == -1  && post.val.inform_method != 2">不推(沒有配對到)</div>
                    <div *ngIf="post.val.is_enable == 0">待配對</div>
                    <div *ngIf="post.val.is_enable == 1 && post.val.inform_method == 2">待發</div>
                    <div *ngIf="post.val.is_enable == 1 && post.val.inform_method != 2">待推</div>
                    <div *ngIf="post.val.is_enable == 2 && post.val.inform_method == 2">已發</div>
                    <div *ngIf="post.val.is_enable == 2 && post.val.inform_method != 2">已推</div>
                    <div *ngIf="post.val.is_enable == 3">已單統計</div>
                    <div *ngIf="post.val.is_enable == 4">已全統計</div>
                </div >

                <div style="display: flex;">
                    <div *ngIf="post.key == 'gg' && (post.val.is_enable == 0 || post.val.is_enable == 1)">
                        <button class="btn btn-success" (click)="once_push = post.val"  data-toggle="modal" data-target=".bd-example-modal-xl" style='margin-left: 10px;'>編輯設定檔</button>
                    </div>
                    <div *ngIf="post.key == 'gg' && post.val.is_enable == 1">
                        <button class="btn btn-warning" (click)="close_push(post.val)"  style='margin-left: 10px;'>取消</button>
                    </div>
                </div>
            </ng-template>
        </app-table-v2>
    </div>
    <div  style="padding:30px;margin-left:10px ;" *ngIf="menu_now=='6'">
        <button class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-xl" (click)="default_type()" style="margin-bottom: 1%;">新增一次性推播設定</button>
        <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent_once_push_type" [data]="data">
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'route_sign'">
                    <div *ngIf="post.val.route_sign == 1">打開App</div>
                    <div *ngIf="post.val.route_sign == 2">探索頁-最新</div>
                    <div *ngIf="post.val.route_sign == 301">動態頁-關注</div>
                    <div *ngIf="post.val.route_sign == 306">動態頁-精選</div>
                    <div *ngIf="post.val.route_sign == 5">動態明細內頁</div>
                    <div *ngIf="post.val.route_sign == 6">對象聊天室</div>
                    <div *ngIf="post.val.route_sign == 11">個人頁</div>
                    <div *ngIf="post.val.route_sign == 14">女性收益報表</div>
                    <div *ngIf="post.val.route_sign == 16">聊天列表</div>
                    <div *ngIf="post.val.route_sign == 20">女會員系統頁</div>
                </div>

                <div *ngIf="post.key == 'is_enable'">
                    <div *ngIf="post.val.is_enable == 0">停用</div>
                    <div *ngIf="post.val.is_enable == 1">啟用</div>
                </div>

                <div *ngIf="post.key == 'gg'">
                    <button class="btn btn-success" (click)="edit_data=post.val;"  data-toggle="modal" data-target=".bd-example-modal-xl" style='margin-left: 10px;'>編輯設定檔</button>
                </div>
            </ng-template>
        </app-table-v2>

    </div>
    <app-pagnation *ngIf="data.length>0" (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
    <div *ngIf="data.length==0">無資料</div>
</div>

<div
    *ngIf="edit_data"
    class="modal fade bd-example-modal-xl" tabindex="-1"
    role="dialog"  data-keyboard="false" data-backdrop="static"
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title">操作</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body" *ngIf="menu_now=='1'">
                <div>
                    <div class="card">
                        <div class="card-header">
                            <h3>設定訊息內容</h3>
                            <hr>
                            <h4>可用變數：</h4> <button class="btn btn-primary" (click)="add_var(item.id)" *ngFor="let item of varable_list" style="margin-right: 3%;">{{item.name}}</button>
                        </div>
                        <div class="card-body blue_left">
                            <div  style="margin-top:13px;">
                                <textarea
                                    style="height: 75px;"
                                    (select)="select($event);mouse_obj.select = 1;mouse_obj.target = 0"
                                    (click)="select($event);mouse_obj.select = 1;mouse_obj.target = 0"
                                    (keyup)="select($event);mouse_obj.select = 1;mouse_obj.target = 0"
                                    class="form-control" [(ngModel)]="edit_data.content_tpl"
                                >
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-body" *ngIf="menu_now=='6'">
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">名稱</label>
                    <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.name">
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">標題</label>
                    <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.title_tpl">
                </div>
                <div class="user_edit_block form-group" style="display: flex;">
                    <label class="col-sm-2 col-form-label">內容</label>
                    <textarea  style="height:64%;width: 70%;"  class="form-control" [(ngModel)]="edit_data.content_tpl"></textarea>
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">App導入頁面</label>
                    <select class="form-control" style="width: 190px;display: inline-block;margin-right: 50px;" [(ngModel)]="edit_data.route_sign">
                        <option default disabled value="-2">請選擇App導入頁面</option>
                        <option *ngFor="let item of route_sign" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                </div>
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">狀態</label>
                    <select class="form-control" style="width: 160px;display: inline-block;margin-right: 50px;" [(ngModel)]="edit_data.is_enable">
                        <option default disabled value="-2">請選擇狀態</option>
                        <option *ngFor="let item of is_enable_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                </div>
            </div>

            <div class="modal-body" *ngIf="menu_now=='3'">
                <div>
                    <div class="card">
                        <div class="card-header">
                            <h3>觸發推播模板設定</h3>
                            <hr>
                            <h4>可用變數：</h4>
                            <button class="btn btn-primary" (click)="add_var_tpl(item.id)" *ngFor="let item of varable_list" style="margin-right: 3%;">{{item.name}}</button>
                        </div>

                        <div class="card-body blue_left">
                            <div  style="margin-top:13px;">
                                <div style="padding: 15px;">
                                    <h6>標題</h6>
                                    <div class="divccc" style="display: flex;">
                                        <div style="width: 100%;">
                                            <textarea
                                                style="height: 35px;"
                                                (select)="select($event);mouse_obj.target = 0"
                                                (click)="select($event);mouse_obj.target = 0"
                                                (keyup)="select($event);mouse_obj.target = 0"
                                                class="form-control" [(ngModel)]="edit_data.title_tpl"
                                            >
                                            </textarea>
                                            <h6 style="margin-top:10px;">內容</h6>
                                            <textarea
                                                (select)="select($event);mouse_obj.target = 1"
                                                (click)="select($event);mouse_obj.target = 1"
                                                (keyup)="select($event);mouse_obj.target = 1"
                                                class="form-control" [(ngModel)]="edit_data.content_tpl"
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-body" *ngIf="now == '1' && menu_now=='2'">
                <div>
                    <div class="card">
                        <div class="card-header">
                            <h3>多標題設定</h3>
                            <hr>
                            <h4>可用變數：</h4>
                            <button class="btn btn-primary" (click)="add_var(item.id)" *ngFor="let item of varable_list" style="margin-right: 3%;">{{item.name}}</button>
                        </div>

                        <div class="card-body blue_left">
                            <button class="btn btn-primary" (click)="add_new_title()">新增多標題</button>
                            <div  style="margin-top:13px;"  *ngFor="let item of edit_data.muti_title;let recordIndex = index" >
                                <div *ngIf="item.status!=0" [style]="(item.is_enable==0)?'background-color: #e1e1e1;padding: 15px;':'padding: 15px;'">
                                    <h3>{{recordIndex+1}}</h3>
                                    <h6>標題</h6>
                                    <div class="divccc" style="display: flex;">
                                        <div style="width: 100%;">
                                            <textarea
                                            style="height: 35px;"
                                            (select)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 0"
                                            (click)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 0"
                                            (keyup)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 0"
                                            class="form-control" [(ngModel)]="item.title_tpl"   [readonly]="(item.is_enable == 0 )?true:false"
                                            (change)="item.status=2">
                                            </textarea>
                                            <h6 style="margin-top:10px;">內容</h6>
                                            <textarea
                                                (select)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 1"
                                                (click)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 1"
                                                (keyup)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 1"
                                                class="form-control" [(ngModel)]="item.content_tpl" [readonly]="(item.is_enable == 0)?true:false"
                                                (change)="item.status=2">
                                            </textarea>
                                        </div>
                                        <div style="margin-left: 2%;">
                                            <button *ngIf="(item.is_enable !=1 && item.is_enable !=0)"   (click)="item.is_enable=0;checkbtn(edit_data.muti_title,item)" class="btn btn-success" style="width: 78px;height: 31%;margin-right: 69px;">啟用中</button>
                                            <button *ngIf="item.is_enable==1"   (click)="item.is_enable=0;checkbtn(edit_data.muti_title,item)" class="btn btn-success" style="width: 78px;height: 31%;margin-right: 69px;">啟用中</button>
                                            <button *ngIf="item.is_enable==0"   (click)="item.is_enable=1;" class="btn btn-secondary" style="width: 78px;height: 31%;margin-right: 69px;">停用中</button>
                                            <button *ngIf="item.id==-1" (click)="item.status=0;" class="btn btn-danger" style="margin-top: 22%;">刪除</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

          <!-- Modal body -->
            <div class="modal-body" *ngIf="now == '2' && edit_data.info.condition  && menu_now=='2'">
                <div>
                    <div class="card">
                        <div class="card-header">
                            <ul class="nav nav-pills card-header-pills nav-justified" id="bologna-list" role="tablist">
                                <li class="nav-item">
                                    <span class="nav-link" style="cursor: pointer;" (click)="sub_now='2'" [class]="sub_now=='2'?'active':''"  role="tab" aria-controls="history" aria-selected="false">推播目標</span>
                                </li>
                                <li class="nav-item">
                                    <span class="nav-link" style="cursor: pointer;"  (click)="sub_now='3'"  [class]="sub_now=='3'?'active':''" role="tab" aria-controls="deals" aria-selected="false">發送時間</span>
                                </li>
                            </ul>
                        </div>
                        <div class="card-body blue_left">
                            <div *ngIf="sub_now=='2'">
                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">推播類型名稱</label>
                                    <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.name">
                                </div>
                                <!-- <div class="user_edit_block form-group">
                                    <div class="card-body blue_left" style="background-color: aliceblue;">
                                        <div class="card-header" style="background-color: aliceblue;">
                                            <h3>模板設定</h3>
                                            <hr>
                                            <h4>可用變數：</h4>
                                            <button class="btn btn-primary" (click)="adds_var(item.id)" *ngFor="let item of varable_list" style="margin-right: 3%;">{{item.name}}</button>
                                        </div>
                                        <div>
                                            <textarea style="height: 35px;" class="form-control" [(ngModel)]="edit_data.title_tpl"
                                            (select)="key='title_tpl'"
                                            (click)="key='title_tpl'"
                                            (keyup)="key='title_tpl'"
                                            placeholder="請輸入標題名稱"
                                            ></textarea>
                                            <textarea style="height: 100px;margin-top: 3px;" class="form-control" [(ngModel)]="edit_data.content_tpl"
                                            (select)="key='content_tpl'"
                                            (click)="key='content_tpl'"
                                            (keyup)="key='content_tpl'"
                                            placeholder="請輸入內容"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">推播對象性別</label>
                                    <input [disabled]="power <= 4"  type="radio" name="推播對象"  class="with-gap" [(ngModel)]="edit_data.gender" [value]="'1'">
                                    <span (click)="edit_data.gender = power > 4 ? '1' : edit_data.gender" style="cursor: pointer;">男生</span>
                                    <input  [disabled]="power <= 4"  type="radio" name="推播對象"  class="with-gap" [(ngModel)]="edit_data.gender" [value]="'2'">
                                    <span (click)="edit_data.gender = power > 4 ? '2' : edit_data.gender" style="cursor: pointer;">女生</span>
                                </div>
                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">推播對象Tag<p style="font-size: 10px;">未填則推給所有該性別</p></label>
                                    <select class="form-control" style="width: 160px;display: inline-block;margin-right: 50px;" [(ngModel)]="tool_obj.tag" (ngModelChange)="showdeType(tool_obj.tag)">
                                        <option default disabled value="-2">請選擇Tag類型</option>
                                        <option *ngFor="let item of tag_list_type" [ngValue]="item.id">{{item.name}}</option>
                                    </select>
                                    <mat-form-field  *ngIf="tool_obj.tag > -1" style="width: 600px;">
                                        <mat-label>選擇呈現類別</mat-label>
                                        <mat-select [(ngModel)]="tool_obj.groupTag" multiple (ngModelChange)="showType(tool_obj.tag)" >
                                            <mat-option *ngFor="let item of groupTaglist[tool_obj.tag]" [value]="item.name">{{ item.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <div  *ngFor="let itex of groupTagArr; let ix = index">
                                        <div *ngIf="itex != null">
                                            <button  *ngFor="let item of itex; let i = index"  style="margin: 10px;" class="btn btn-primary"  (click)="clearbtn(item,ix,i)" >{{item}}</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">推薦對象Tag<p style="font-size: 10px;">未填則不推薦特定用戶</p></label>
                                    <select class="form-control" style="width: 160px;display: inline-block;margin-right: 50px;" [(ngModel)]="tool_obj.tag1" (ngModelChange)="showdeType1(tool_obj.tag1)">
                                        <option default disabled value="-2">請選擇Tag類型</option>
                                        <option *ngFor="let item of tag_list_type" [ngValue]="item.id">{{item.name}}</option>
                                    </select>
                                    <mat-form-field  *ngIf="tool_obj.tag1 > -1" style="width: 600px;">
                                        <mat-label>選擇呈現類別</mat-label>
                                        <mat-select [(ngModel)]="tool_obj.groupTag1" multiple (ngModelChange)="showType1(tool_obj.tag1)" >
                                            <mat-option *ngFor="let item of groupTaglist[tool_obj.tag1]" [value]="item.name">{{ item.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <div  *ngFor="let itex of groupTagArr1; let ix = index">
                                        <div *ngIf="itex != null">
                                            <button  *ngFor="let item of itex; let i = index"  style="margin: 10px;" class="btn btn-info"  (click)="clearbtn1(item,ix,i)" >{{item}}</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="user_edit_block form-group" *ngIf="groupTagArr1?.length > 0">
                                    <label class="col-sm-2 col-form-label">推薦對象拆分：</label>
                                    <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.info.is_split">
                                </div>
                                <div class="user_edit_block form-group" *ngIf="tool_obj.groupTag1?.length > 0">
                                    <label class="col-sm-2 col-form-label">推播圖片</label>
                                    <input [disabled]="power <= 4"  type="radio" name="推播圖"  class="with-gap" [(ngModel)]="edit_data.info.has_pic" [value]="1">
                                    <span (click)="edit_data.info.has_pic = power > 4 ? 1 : edit_data.info.has_pic" style="cursor: pointer;">大頭貼</span>
                                    <input [disabled]="power <= 4"  type="radio" name="推播圖"  class="with-gap" [(ngModel)]="edit_data.info.has_pic" [value]="2">
                                    <span (click)="edit_data.info.has_pic = power > 4 ? 2 : edit_data.info.has_pic" style="cursor: pointer;">動態</span>
                                    <input [disabled]="power <= 4"  type="radio" name="推播圖"  class="with-gap" [(ngModel)]="edit_data.info.has_pic" [value]="0">
                                    <span (click)="edit_data.info.has_pic = power > 4 ? 0 : edit_data.info.has_pic" style="cursor: pointer;">無</span>
                                </div>

                                <div class="user_edit_block form-group" *ngIf="tool_obj.groupTag1?.length > 0 && edit_data.info.has_pic!=0">
                                    <label class="col-sm-2 col-form-label">圖片模糊化</label>
                                    <input [disabled]="power <= 4"  type="radio" name="模糊"  class="with-gap" [(ngModel)]="edit_data.info.is_fuzzy" [value]="1">
                                    <span (click)="edit_data.info.is_fuzzy = power > 4 ? 1 : edit_data.info.is_fuzzy" style="cursor: pointer;">是</span>
                                    <input [disabled]="power <= 4"  type="radio" name="模糊"  class="with-gap" [(ngModel)]="edit_data.info.is_fuzzy" [value]="0">
                                    <span (click)="edit_data.info.is_fuzzy = power > 4 ? 0 : edit_data.info.is_fuzzy" style="cursor: pointer;">否</span>
                                </div>

                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">APP導入頁面</label>
                                    <select class="form-control" style="width: 20%;display: inline-block;margin-right: 50px;" [(ngModel)]="edit_data.route_sign">
                                        <option default disabled value="-1">請選擇APP導入頁面</option>
                                        <option *ngFor="let item of route_sign" [ngValue]="item.id">{{item.name}}</option>
                                    </select>
                                </div>
                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">是否啟用</label>
                                    <input [disabled]="power <= 4"  type="radio" name="啟用"  class="with-gap" [(ngModel)]="edit_data.is_enable" [value]="'1'">
                                    <span (click)="edit_data.is_enable  = power > 4 ? '1': edit_data.is_enable" style="cursor: pointer;">是</span>
                                    <input [disabled]="power <= 4"  type="radio" name="啟用"  class="with-gap" [(ngModel)]="edit_data.is_enable" [value]="'0'">
                                    <span (click)="edit_data.is_enable = power > 4 ? '0' : edit_data.is_enable" style="cursor: pointer;">否</span>
                                </div>
                            </div>

                            <div *ngIf="sub_now=='3'">
                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">發送時間</label>
                                    <select  [disabled]="power <= 4" name="selectedQuantity"  class="form-control" [(ngModel)]="edit_data.ps_id" style="width: 20%;display: inline-block;margin-right: 50px;">
                                        <option *ngFor="let option of time_list" [value]="option.id" >{{option.name}}</option>
                                    </select>
                                </div>
                                <div class="user_edit_block form-group">
                                    <button *ngIf="power > 4" (click)="edit_data.info.available_week=[0,1,2,3,4,5,6]" class="btn btn-primary" style="margin-right: 1%;">每天</button>
                                    <button *ngIf="power > 4" (click)="edit_data.info.available_week=[0,6]" class="btn btn-primary">周末</button>
                                </div>
                                <div class="user_edit_block form-group" style="display: flex;">
                                    <label class="col-sm-2 col-form-label">發送日</label>
                                    <div  style="width: 50%;">
                                        <div class="tips">請選擇發送日為哪幾天</div>
                                        <ul class="list-group">
                                            <li class="list-group-item" *ngFor="let item of day_list">
                                                <input type="checkbox"
                                                    [disabled]="power <= 4"
                                                    [checked]="edit_data.info.available_week.includes(item.id*1)"
                                                    name="list_name" value="{{item.id}}"
                                                    (change)="ck_date(edit_data.info.available_week,item.id*1)"/>

                                                <span (click)="power > 4 ? ck_date(edit_data.info.available_week,item.id*1):power=power;" style="cursor: pointer;">{{item.name}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             <!-- Modal body -->
             <div class="modal-body" *ngIf="now == '3' && menu_now !='5'">
                <div>
                    <div class="card">
                        <div class="card-header" *ngIf="menu_now != '6'">
                            <ul class="nav nav-pills card-header-pills nav-justified" id="bologna-list" role="tablist">
                                <li class="nav-item">
                                    <span class="nav-link" style="cursor: pointer;" (click)="sub_now='2'" [class]="sub_now=='2'?'active':''"  role="tab" aria-controls="history" aria-selected="false">推播目標</span>
                                </li>
                                <li class="nav-item">
                                    <span class="nav-link" style="cursor: pointer;"  (click)="sub_now='3'"  [class]="sub_now=='3'?'active':''" role="tab" aria-controls="deals" aria-selected="false">發送時間</span>
                                </li>
                            </ul>
                        </div>
                        <div class="card-body blue_left" *ngIf="menu_now != '6'">
                            <div *ngIf="sub_now=='2' && menu_now != '6'">
                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">推播類型名稱</label>
                                    <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.name">
                                </div>
                                <div class="user_edit_block form-group">
                                    <div class="card-body blue_left" style="background-color: aliceblue;">
                                        <div class="card-header" style="background-color: aliceblue;">
                                            <h3>模板設定</h3>
                                            <hr>
                                            <h4>可用變數：</h4>
                                            <button class="btn btn-primary" (click)="adds_var(item.id)" *ngFor="let item of varable_list" style="margin-right: 3%;">{{item.name}}</button>
                                        </div>
                                        <div>
                                            <textarea style="height: 35px;" class="form-control" [(ngModel)]="edit_data.title_tpl"
                                            (select)="key='title_tpl'"
                                            (click)="key='title_tpl'"
                                            (keyup)="key='title_tpl'"
                                            placeholder="請輸入標題名稱"
                                            ></textarea>
                                            <textarea style="height: 100px;margin-top: 3px;" class="form-control" [(ngModel)]="edit_data.content_tpl"
                                            (select)="key='content_tpl'"
                                            (click)="key='content_tpl'"
                                            (keyup)="key='content_tpl'"
                                            placeholder="請輸入內容"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">推播對象性別</label>
                                    <input [disabled]="power <= 4"  type="radio" name="推播對象"  class="with-gap" [(ngModel)]="edit_data.gender" [value]="'1'">
                                    <span (click)="edit_data.gender = power > 4 ? '1' : edit_data.gender" style="cursor: pointer;">男生</span>
                                    <input  [disabled]="power <= 4"  type="radio" name="推播對象"  class="with-gap" [(ngModel)]="edit_data.gender" [value]="'2'">
                                    <span (click)="edit_data.gender = power > 4 ? '2' : edit_data.gender" style="cursor: pointer;">女生</span>
                                </div>
                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">推播對象Tag<p style="font-size: 10px;">未填則推給所有該性別</p></label>
                                    <select class="form-control" style="width: 160px;display: inline-block;margin-right: 50px;" [(ngModel)]="tool_obj.tag" (ngModelChange)="showdeType(tool_obj.tag)">
                                        <option default disabled value="-2">請選擇Tag類型</option>
                                        <option *ngFor="let item of tag_list_type" [ngValue]="item.id">{{item.name}}</option>
                                    </select>
                                    <mat-form-field  *ngIf="tool_obj.tag > -1" style="width: 600px;">
                                        <mat-label>選擇呈現類別</mat-label>
                                        <mat-select [(ngModel)]="tool_obj.groupTag" multiple (ngModelChange)="showType(tool_obj.tag)" >
                                            <mat-option *ngFor="let item of groupTaglist[tool_obj.tag]" [value]="item.name">{{ item.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <div  *ngFor="let itex of groupTagArr; let ix = index">
                                        <div *ngIf="itex != null">
                                            <button  *ngFor="let item of itex; let i = index"  style="margin: 10px;" class="btn btn-primary"  (click)="clearbtn(item,ix,i)" >{{item}}</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">推薦對象Tag<p style="font-size: 10px;">未填則不推薦特定用戶</p></label>
                                    <select class="form-control" style="width: 160px;display: inline-block;margin-right: 50px;" [(ngModel)]="tool_obj.tag1" (ngModelChange)="showdeType1(tool_obj.tag1)">
                                        <option default disabled value="-2">請選擇Tag類型</option>
                                        <option *ngFor="let item of tag_list_type" [ngValue]="item.id">{{item.name}}</option>
                                    </select>
                                    <mat-form-field  *ngIf="tool_obj.tag1 > -1" style="width: 600px;">
                                        <mat-label>選擇呈現類別</mat-label>
                                        <mat-select [(ngModel)]="tool_obj.groupTag1" multiple (ngModelChange)="showType1(tool_obj.tag1)" >
                                            <mat-option *ngFor="let item of groupTaglist[tool_obj.tag1]" [value]="item.name">{{ item.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <div  *ngFor="let itex of groupTagArr1; let ix = index">
                                        <div *ngIf="itex != null">
                                            <button  *ngFor="let item of itex; let i = index"  style="margin: 10px;" class="btn btn-info"  (click)="clearbtn1(item,ix,i)" >{{item}}</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="user_edit_block form-group" *ngIf="groupTagArr1?.length > 0">
                                    <label class="col-sm-2 col-form-label">推薦對象拆分：</label>
                                    <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.info.is_split">
                                </div>
                                <div class="user_edit_block form-group" *ngIf="tool_obj.groupTag1?.length > 0">
                                    <label class="col-sm-2 col-form-label">推播圖片</label>
                                    <input [disabled]="power <= 4"  type="radio" name="推播圖"  class="with-gap" [(ngModel)]="edit_data.info.has_pic" [value]="1">
                                    <span (click)="edit_data.info.has_pic = power > 4 ? 1 : edit_data.info.has_pic" style="cursor: pointer;">大頭貼</span>
                                    <input [disabled]="power <= 4"  type="radio" name="推播圖"  class="with-gap" [(ngModel)]="edit_data.info.has_pic" [value]="2">
                                    <span (click)="edit_data.info.has_pic = power > 4 ? 2 : edit_data.info.has_pic" style="cursor: pointer;">動態</span>
                                    <input [disabled]="power <= 4"  type="radio" name="推播圖"  class="with-gap" [(ngModel)]="edit_data.info.has_pic" [value]="0">
                                    <span (click)="edit_data.info.has_pic = power > 4 ? 0 : edit_data.info.has_pic" style="cursor: pointer;">無</span>
                                </div>

                                <div class="user_edit_block form-group" *ngIf="tool_obj.groupTag1?.length > 0 && edit_data.info.has_pic!=0">
                                    <label class="col-sm-2 col-form-label">圖片模糊化</label>
                                    <input [disabled]="power <= 4"  type="radio" name="模糊"  class="with-gap" [(ngModel)]="edit_data.info.is_fuzzy" [value]="1">
                                    <span (click)="edit_data.info.is_fuzzy = power > 4 ? 1 : edit_data.info.is_fuzzy" style="cursor: pointer;">是</span>
                                    <input [disabled]="power <= 4"  type="radio" name="模糊"  class="with-gap" [(ngModel)]="edit_data.info.is_fuzzy" [value]="0">
                                    <span (click)="edit_data.info.is_fuzzy = power > 4 ? 0 : edit_data.info.is_fuzzy" style="cursor: pointer;">否</span>
                                </div>

                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">APP導入頁面</label>
                                    <select class="form-control" style="width: 20%;display: inline-block;margin-right: 50px;" [(ngModel)]="edit_data.route_sign">
                                        <option default disabled value="-1">請選擇APP導入頁面</option>
                                        <option *ngFor="let item of route_sign" [ngValue]="item.id">{{item.name}}</option>
                                    </select>
                                </div>
                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">是否啟用</label>
                                    <input [disabled]="power <= 4"  type="radio" name="啟用"  class="with-gap" [(ngModel)]="edit_data.is_enable" [value]="'1'">
                                    <span (click)="edit_data.is_enable  = power > 4 ? '1': edit_data.is_enable" style="cursor: pointer;">是</span>
                                    <input [disabled]="power <= 4"  type="radio" name="啟用"  class="with-gap" [(ngModel)]="edit_data.is_enable" [value]="'0'">
                                    <span (click)="edit_data.is_enable = power > 4 ? '0' : edit_data.is_enable" style="cursor: pointer;">否</span>
                                </div>
                            </div>

                            <div *ngIf="sub_now=='3' && menu_now != '6'">
                                <div class="user_edit_block form-group">
                                    <label class="col-sm-2 col-form-label">發送時間</label>
                                    <select  [disabled]="power <= 4" name="selectedQuantity"  class="form-control" [(ngModel)]="edit_data.ps_id" style="width: 20%;display: inline-block;margin-right: 50px;">
                                        <option *ngFor="let option of time_list" [value]="option.id" >{{option.name}}</option>
                                    </select>
                                </div>
                                <div class="user_edit_block form-group">
                                    <button *ngIf="power > 4" (click)="edit_data.info.available_week=[0,1,2,3,4,5,6]" class="btn btn-primary" style="margin-right: 1%;">每天</button>
                                    <button *ngIf="power > 4" (click)="edit_data.info.available_week=[0,6]" class="btn btn-primary">周末</button>
                                </div>
                                <div class="user_edit_block form-group" style="display: flex;">
                                    <label class="col-sm-2 col-form-label">發送日</label>
                                    <div  style="width: 50%;">
                                        <div class="tips">請選擇發送日為哪幾天</div>
                                        <ul class="list-group">
                                            <li class="list-group-item" *ngFor="let item of day_list">
                                                <input type="checkbox"
                                                    [disabled]="power <= 4"
                                                    [checked]="edit_data.info.available_week.includes(item.id*1)"
                                                    name="list_name" value="{{item.id}}"
                                                    (change)="ck_date(edit_data.info.available_week,item.id*1)"/>

                                                <span (click)="power > 4 ? ck_date(edit_data.info.available_week,item.id*1):power=power;" style="cursor: pointer;">{{item.name}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-body" *ngIf="menu_now=='5'">
                <div>

                    <div class="user_edit_block form-group" *ngIf="once_push.inform_method != 2">
                        <label class="col-sm-2 col-form-label custom">標題</label>
                        <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="once_push.title" [disabled]="(once_push.is_enable != 0 && once_push.is_enable != 1)">
                    </div>
                    <div class="user_edit_block form-group" style="display: flex;">
                        <label class="col-sm-2 col-form-label custom">內容</label>
                        <textarea class="form-control" style="width: 500px; height: 100px;" [(ngModel)]="once_push.content" [disabled]="(once_push.is_enable != 0 && once_push.is_enable != 1)"></textarea>
                    </div>

                    <div class="user_edit_block form-group" style="display: flex;">
                        <label class="col-sm-2 col-form-label custom">狀態</label>
                        <select class="form-control" style="width: 160px;display: inline-block;" [(ngModel)]="once_push.is_enable">
                            <option *ngFor="let item of is_enable_push_list" [ngValue]="item.id">{{item.name}}</option>
                        </select>
                    </div>

                    <div class="user_edit_block form-group">
                        <label  class="col-sm-2 col-form-label custom"  for="datetime">發送時間</label>
                        <input type="datetime-local" id="datetime" name="datetime" [disabled]="(once_push.is_enable != 0 && once_push.is_enable != 1)"  [(ngModel)]="once_push.push_time" required>
                    </div>

               </div>
            </div>
          <!-- Modal footer -->
            <div class="modal-footer" *ngIf="menu_now=='1'">
                <button type="button"  (click)="save(edit_data,now)"  class="btn btn-primary" data-dismiss="modal">確認</button>
                <button type="button" (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
            <div class="modal-footer" *ngIf="menu_now=='2'">
                <button type="button" *ngIf="sub_now == '2' && now != '1'" (click)="next()"  class="btn btn-primary" data-dismiss="modal">下一步</button>
                <button type="button" *ngIf="(((now=='2' && power>4)  && sub_now == '3' )|| now =='1')" (click)="save(edit_data,now)"  class="btn btn-primary" data-dismiss="modal">確認</button>
                <button type="button" *ngIf="now=='3' && sub_now == '3'" (click)="save(edit_data,now)"  class="btn btn-primary" data-dismiss="modal">確認</button>
                <button type="button" (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
            <div class="modal-footer" *ngIf="menu_now=='3'">
                <button type="button"  (click)="save_push_type_tpl_list(edit_data)"  class="btn btn-primary" data-dismiss="modal">確認</button>
                <button type="button" (click)="init_push_type_tpl_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
            <div class="modal-footer" *ngIf="menu_now=='5'">
                <button type="button" (click)="save_one_push(once_push)"  class="btn btn-primary" data-dismiss="modal">確認</button>
                <button type="button" (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
            <div class="modal-footer" *ngIf="menu_now=='6'">
                <button type="button" (click)="save_one_push_type(edit_data)"  class="btn btn-primary" *ngIf="edit_data.route_sign == -2">確認</button>
                <button type="button" (click)="save_one_push_type(edit_data)"  class="btn btn-primary" data-dismiss="modal" *ngIf="edit_data.route_sign != -2">確認</button>
                <button type="button" (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
        </div>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>
